module.exports = __webpack_public_path__ + "media/alarm.cf9e2144.wav";